import React from 'react';
import PropTypes from 'prop-types';
import {ChapterMenu} from '../../ChapterMenu';

/**
 * Menu:
 *  - Single Menu for Notebook
 */
export function Menu(props) {
  const onClick = () => !props.current && props.onSelect();

  const getClassName = (sub = '') => props.className + sub;

  return (
    <ChapterMenu.Wrapper
      className={getClassName()}
      onClick={onClick}
      onEnterKey={onClick}
      tabIndex={props.tabIndex}>
      <ChapterMenu.IndexNumber
        className={getClassName('_indexNumber')}
        number={props.number}
        visited={props.visited}
      />
      <ChapterMenu.Label
        className={getClassName('_label')}
        title={props.title}
      />
    </ChapterMenu.Wrapper>
  );
}

Menu.propTypes = {
  /**
   * Callback fired when a Menu is Selected
   */
  onSelect: PropTypes.func,
  /**
   * Title to display in  menu
   */
  title: PropTypes.string.isRequired,
  /**
   * Boolean specifying if menu is selected
   */
  current: PropTypes.bool.isRequired,
  /**
   * Index number of menu
   */
  number: PropTypes.number.isRequired,
  /**
   * TabIndex to set on Menu
   */
  tabIndex: PropTypes.number,
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Boolean set if Section is visited
   */
  visited: PropTypes.bool,
};

Menu.defaultProps = {
  className: '',
  title: '',
  number: 0,
  tabIndex: 0,
};

